module.exports = __webpack_public_path__ + "img/Img3b_204707_EiBg-7-1-63.275f1c68.jpg";